// Logout.js
import React from "react";
import Swal from "sweetalert2";
import { useUser } from "../../context/UserContext"; // adjust path
import ExitToAppSharpIcon from "@mui/icons-material/ExitToAppSharp";

const Logout = () => {
  const { setUser } = useUser();

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear storage
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        sessionStorage.clear();
        setUser(null);

        Swal.fire("Logged Out!", "You have been successfully logged out.", "success").then(() => {
          // Redirect after alert closes
          window.location.href = "/"; // Change to your login route
        });
      }
    });
  };

  return (
    <p onClick={handleLogout} style={{ fontWeight: "700",cursor:"pointer" }} >
     <i class="fa fa-sign-out" aria-hidden="true"></i>&nbsp;
  Sign-Out
    </p>
  );
};

export default Logout;
